import React, { useEffect } from 'react'
import moment from 'moment'

import {
  Box,
  Grid,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'
import { Truckload } from 'src/api/models'
import useProfileContext from 'src/context/ProfileContext'

const useStyles = makeStyles(() => ({
  label: {
    maxWidth: '90%',
    margin: 'auto',
    border: '1px solid gray',
    borderRadius: '1rem',
    padding: '0.5rem',
  },
}))

interface Props {
  truckload: Truckload
  onReadyToPrint?: () => void
}

export const TruckloadLabel = (props: Props) => {
  const { truckload, onReadyToPrint } = props
  const barcode = { barcode: truckload.guid, type: 'datamatrix', displayName: '' }
  const classes = useStyles()

  const profileContext = useProfileContext()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box px={10} pt={20}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={4}
          className={classes.label}
        >
          <Grid item xs={3}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={9}>
            <Box>
              <Typography variant="h1">{truckload.name}</Typography>
            </Box>
            <Box>
              <Typography variant="h5">{truckload.guid}</Typography>
            </Box>
            <Box>
              <Typography variant="caption">Printed on {moment().format('lll')} by {profileContext.profile?.firstName} {profileContext.profile?.lastName}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
